module.exports = __webpack_public_path__ + "static/media/profile.37d59626.jpg";